import React, {Component} from 'react';
import {connect} from "react-redux";
import logicGraphDataActions from "../../../actions/logicGraphDataActions";

import MaterialIcon from '../../MaterialIcon';
import uniqueId from 'lodash/uniqueId';
import { ReactSortable } from 'react-sortablejs';


import {removePort, addPort} from './InputPortListUtils/InputPortUtils';

class InputPortList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            portList: [],
            options: {
                inputPortData: [],
                expression: '',
            }

        };
        this.createList = this.createList.bind(this);
        this.createOption = this.createOption.bind(this);
        this.removePort = this.removePort.bind(this);
        this.addPort = this.addPort.bind(this);
        this.inputHandle = this.inputHandle.bind(this);
        this.onOptionsUpdate = this.onOptionsUpdate.bind(this);
    }

    componentDidMount(){
        this.createList();
    }

    // eslint-disable-next-line no-unused-vars
    onOptionsUpdate(type, value, portID) {
        const portList = Object.values(Object.assign({}, this.state.portList));
        this.setState({
            portList: portList
        }, () => this.createOption());
    }

    createList(){
        const engine = this.props.logicDataInfo;
        const model = engine.getModel();
        const logicData = model.serialize();
        
        const clickedNodeInfo = Object.assign({}, this.props.clickedNodeInfo);
        const portList = [];
        const inputPortData = clickedNodeInfo.extras.options.inputPortData;

        let clickedNodeInfoPorts = Object.values(clickedNodeInfo.ports);
        if(!clickedNodeInfoPorts[0].in){
            const clickedNodeInfoFirstPort = clickedNodeInfoPorts[0];
            clickedNodeInfoPorts.shift();
            clickedNodeInfoPorts.push(clickedNodeInfoFirstPort);
        }
        clickedNodeInfoPorts.forEach((v,i) => {
            const values = {
                variableName: '',
                dynamicPropertyName: ''
            };

            if(typeof inputPortData !== 'undefined' && inputPortData.length > 0 && v.options.in){
                values.variableName = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].variableName : '';
                values.dynamicPropertyName = typeof inputPortData[i] !== 'undefined' ? inputPortData[i].dynamicPropertyName : '';
            }

            const createData = {
                parentID: clickedNodeInfo.options.id,
                id: v.options.id,
                nodeName: 'Empty Input',
                index: 0,
                sectionType: 'empty',
                variableName: values.variableName,
                dynamicPropertyName: values.dynamicPropertyName,
                in: v.options.in
            };

            if(v.connection){
                let nodeID = '';
                Object.values(logicData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(link => {
                    if(link.sourcePort === v.options.id){
                        nodeID = link.target;
                    }
                    if(link.targetPort === v.options.id){
                        nodeID = link.source;
                    }   
                });
                const nodeData = Object.values(logicData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0];
                createData.nodeName = nodeData.name;
                createData.sectionType = nodeData.sectionType;
                createData.index = i;
                portList.push(createData);
            }else {
                createData.index = i;
                portList.push(createData);
            }
        });

        const newPortList = [];
        const inputPortList = portList.filter(port => port.in);
        const outputPortList = portList.filter(port => port.in === false);

        inputPortList.forEach((v,i) => {
            v.index = i;
            newPortList.push(v);
        });
        outputPortList.forEach((v) => {
            newPortList.push(v);
        });
        
        this.setState(
            { portList: newPortList },
            () => this.createOption()
        );
    }

    createOption(){
        const inputPortData = [];
        const portList = Object.values(Object.assign({}, this.state.portList));

        const inputPortList = portList.filter(port => port.in);
        inputPortList.forEach(v => {
            inputPortData.push({
                variableName: v.variableName,
                dynamicPropertyName: v.dynamicPropertyName
            });

        });

        const options = Object.assign({}, this.state.options);
        options.inputPortData = inputPortData;
        options.expression = this.props.clickedNodeInfo.extras.options.expression;
        options.outputScoreName = this.props.clickedNodeInfo.extras.options.outputScoreName;
        const logicGraphData = {
            options: options,
            portList: portList,
            id: this.props.clickedNodeInfo.options.id
        };
        this.props.logicGraphDataActions(logicGraphData);
    }
    
    removePort(item){
        const portList = removePort(this.state.portList,item);
        this.setState({
            portList: portList
        }, () => this.createOption());
    }
    addPort(){
        const buttonNumber = this.state.portList.length;
        const portList = addPort(this.state, this.props.clickedNodeInfo.options.id, 'combinator', buttonNumber);
        this.setState({
            portList: portList
        }, () => this.createOption());
    }
    
    inputHandle(event,item, name){
        let process = false;
        const portList = Object.assign({}, this.state.portList);
        const setInputData = Object.values(portList).map((v) => {
            if(v.id === item.id){
                if(name === 'variableName' && v.variableName !== event.target.value){
                    v.variableName = event.target.value;
                    process = true;
                }

                if(name === 'dynamicPropertyName' && v.dynamicPropertyName !== event.target.value){
                    v.dynamicPropertyName = event.target.value;
                    process = true;
                }

            }
            return v;
        });
        if(process){
            this.setState({
                portList: setInputData
            }, () => this.createOption());
        }
    }

    render(){
        const defaultPort = (data) => {
            if (data.length === 0) return [];
            const portList = this.state.portList;
            const outputCount = portList.filter(port => !port.in).length;
            const inputPortListCount = portList.length - outputCount;

            let hiddenPortID = '';

            return data.map((val) => {
                const hiddenClassName = hiddenPortID === val.id ? 'hidden' : '';
                return (
                    <div className={`input-area ${val.sectionType} ${hiddenClassName}`} data-id={val.id} key={val.id}>
                        <div className="input-container">
                            <div className="input">
                                <div className="input-name">
                                    <span className="name">{val.nodeName}</span>
                                    <span className="input-index">{val.index}</span>
                                </div>
                                <div className="drag-handle">
                                    <MaterialIcon icon="drag_indicator" size={24}/>
                                </div>
                                <div className="input-editor">
                                    <span className="input-editor-name">Variable Name</span>
                                    <input className="panel-input" onBlur={(event) => this.inputHandle(event, val, 'variableName')} defaultValue={val.variableName} type="text" placeholder="Variable Name"/>
                                </div>
                                <div className="input-editor">
                                    <span className="input-editor-name">Dynamic Property Name</span>
                                    <input className="panel-input" onBlur={(event) => this.inputHandle(event, val, 'dynamicPropertyName')} defaultValue={val.dynamicPropertyName} type="text" placeholder="Dynamic Property Name"/>
                                </div>
                                <div className="action-area">
                                    {
                                        inputPortListCount > 1 &&
                                        <button className="remove-button round" onClick={() => this.removePort(val)}><MaterialIcon icon="close"/></button>
                                    }
                                </div>
                            </div>
                            
                        </div>
                    </div>
                )
            })
        };
        const groupCreate = () => {
            const portListData = this.state.portList.filter(port => port.in);

            const roundRobin = portListData.filter(port => port.roundRobin).length > 0 ? 'round-robin' : '';
            return (
                <ReactSortable key = "static"
                    animation = {150}
                    handle = '.drag-handle' 
                    group = {'default_group' + uniqueId()}
                    pull = {true}
                    put = {true}

                    list={portListData}
                    setList = {(newState)=> {
                        if (portListData.length !== newState.length || !portListData.every((val, index) => val === newState[index])) {
                            const newPortList = [...newState];
                            newPortList.forEach((val,key) => {
                                val.index = key;
                                return val;
                            });
                            const outputPortList = this.state.portList.filter(port => port.in === false);
                            outputPortList.forEach((v) => {
                                newPortList.push(v);
                            });
                            
                            this.setState(
                                { portList: newPortList },
                                () => this.createOption()
                            );
                        }
                    }}
                    className={`list-area ${roundRobin} group-${portListData.length ? portListData[0].groupID : ''}`}
                >
                    {defaultPort(portListData)}
                </ReactSortable>
            )
        };
        return (
            <div className="node-input-list">
                {
                    this.state.portList && groupCreate()
                }
                <div className="bottom-button-area">
                    <button className="add-button" onClick={this.addPort}><MaterialIcon icon="add_circle"/>Add Input</button>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        logicDataInfo: state.logicDataInfo,
        logicGraphData: state.logicGraphData
    }
}
export default connect(mapStateToProps, {logicGraphDataActions})(InputPortList);
